// services/passwordHandler.js

import {
    resetPassword,
    confirmResetPassword,
  } from "aws-amplify/auth";
  
  // Step 1: Trigger password reset email
  export const sendPasswordResetEmail = async (email) => {
    return await resetPassword({ username: email });
  };
  
  // Step 2: Confirm password reset with code and new password
  export const confirmPasswordReset = async (email, code, newPassword) => {
    return await confirmResetPassword({
      username: email,
      confirmationCode: code,
      newPassword: newPassword,
    });
  };
  